import { useFetchCustomTheme } from '../pages/settings-customHook'

export const NoPropertiesFound = () => {
    const { data: themeConfig } = useFetchCustomTheme()
    return (
        <div className="flex flex-col p-40 max-md:px-5 max-md:mt-20 max-md:py-5 gap-20 items-center justify-center h-full">
            <img
                src="/svg/no-property-found.svg"
                alt=""
                className="max-md:w-[50%] w-[20vw]"
            />
            <div className="max-md:max-w-[100%] text-center">
                <p
                    className={`text-xl max-md:text-sm max-md:whitespace-normal`}
                    style={{ color: themeConfig?.visibleTextColor }}
                >
                    You do not have any assigned properties.
                </p>
                <p
                    className={`text-xl max-md:text-sm max-md:whitespace-normal`}
                    style={{ color: themeConfig?.visibleTextColor }}
                >
                    Please contact your account manager for further details or
                    assistance.
                </p>
            </div>
        </div>
    )
}
